import type { statusOptionsValues } from "@dealer-center/ddc-pages-inventory-config-interface";
import { statusOptionsGetLabel } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { getDifferencesBetweenConfigsReturn } from ".";

export function RenderStatusChange(change: getDifferencesBetweenConfigsReturn) {
  const oldValuesAsString = (change.oldValue as statusOptionsValues[]).map(
    item => statusOptionsGetLabel(item)
  );
  const newValuesAsString = (change.newValue as statusOptionsValues[]).map(
    item => statusOptionsGetLabel(item)
  );
  return (
    <li>
      <b>{change.config}</b> changed from{" "}
      <b>"{oldValuesAsString.join(", ")}"</b> to{" "}
      <b>"{newValuesAsString.join(", ")}"</b>
    </li>
  );
}
